import html2canvas from "html2canvas";

export default {
  extractWordDocumentContent(title, bodyHTML, styles, config) {
    var landscapeView = `<style type="text/css" media="print">
			  @page { size: landscape; }
			</style>`;
    var header = `
			<head><meta charset='utf-8'>
				<title>${title}</title>
				<style type="text/css">${styles}</style>
				${config.landscape ? landscapeView : ""}
			</head><body>`;
    var footer = `</body>`;
    var sourceHTML = header + bodyHTML + footer;

    var printWin = window.open("", "", "left=0,top=0,toolbar=0,scrollbars=0,status =0");
    printWin.document.write(sourceHTML);
    printWin.document.close();

    const delayMs = config?.delayMs ?? 1000;
    const waitForImages = () => {
      const images = Array.from(printWin.document.images || []);
      const pending = images.filter((img) => !img.complete);
      if (!pending.length) return Promise.resolve();
      return Promise.all(
        pending.map(
          (img) =>
            new Promise((resolve) => {
              img.addEventListener("load", resolve, { once: true });
              img.addEventListener("error", resolve, { once: true });
            })
        )
      );
    };

    setTimeout(() => {
      waitForImages().then(() => {
        printWin.focus();
        printWin.print();
        printWin.close();
      });
    }, delayMs);
  },
  getImageUri(elementId) {
    return new Promise((resolve, reject) => {
      const img = document.getElementById(elementId);
      if (!img) return resolve(null);

      html2canvas(img, {}).then((canvas) => {
        const dataurl = canvas.toDataURL("image/png", 1.0);
        resolve(dataurl);
      });
    });
  },
};
